<template>
    <a class="flex rounded-full bg-white shadow-md w-16 h-16 cursor-pointer justify-center items-center">
        <slot />
    </a>
</template>
